import { render, staticRenderFns } from "./vip-button-new.vue?vue&type=template&id=19dc3860&scoped=true&lang=pug&"
import script from "./vip-button-new.vue?vue&type=script&lang=js&"
export * from "./vip-button-new.vue?vue&type=script&lang=js&"
import style0 from "./vip-button-new.vue?vue&type=style&index=0&id=19dc3860&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc3860",
  null
  
)

export default component.exports